import React from "react";

const VideoCard = () => {
  return (
    <div className="videoCard">
      <iframe
        src="https://www.youtube.com/embed/i11TceowUT0"
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen={true}
      ></iframe>
    </div>
  );
};

export default VideoCard;
